<template>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button 
        class="accordion-button" 
        type="button"
        :class="{ collapsed: !isOpen }"
        @click="toggle"
      >
        <span class="accordion-icon">
          <i class="fas" :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
        <span class="accordion-text">{{ title }}</span>
      </button>
    </h2>
    <div 
      class="accordion-collapse"
      :class="{ 'is-open': isOpen }"
      :style="{ maxHeight: isOpen && contentHeight > 0 ? contentHeight + 'px' : '0px' }"
    >
      <div class="accordion-body" ref="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionItem',
  props: {
    title: {
      type: String,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.defaultOpen,
      contentHeight: 0
    }
  },
  mounted() {
    if (this.isOpen) {
      // Se è aperto di default, aspetta che il DOM sia completamente renderizzato
      setTimeout(() => {
        this.updateHeight()
      }, 50)
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // Quando si apre, calcola l'altezza dopo che il DOM è aggiornato
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateHeight()
          }, 10)
        })
      }
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    updateHeight() {
      const body = this.$el.querySelector('.accordion-body')
      if (body) {
        // Calcola l'altezza reale del contenuto
        const height = body.scrollHeight
        if (height > 0) {
          this.contentHeight = height
        }
      }
    }
  }
}
</script>

<style scoped>
.accordion-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-item:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.accordion-header {
  margin: 0;
}

.accordion-button {
  width: 100%;
  padding: 20px 24px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1f3a;
  outline: none;
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

.accordion-button:focus-visible {
  outline: none;
  box-shadow: none;
}

.accordion-button:hover {
  background: rgba(42, 82, 152, 0.05);
}

.accordion-button:not(.collapsed) {
  background: rgba(42, 82, 152, 0.08);
  color: #2a5298;
}

.accordion-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(42, 82, 152, 0.1);
  border-radius: 8px;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-button:not(.collapsed) .accordion-icon {
  background: #2a5298;
  color: #ffffff;
}

.accordion-icon i {
  font-size: 0.875rem;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-text {
  flex: 1;
}

.accordion-collapse {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.1s,
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
  opacity: 0;
  transform: translateY(-10px);
}

.accordion-collapse.is-open {
  opacity: 1;
  transform: translateY(0);
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-body {
  padding: 0 24px 24px 72px;
  color: #6b7280;
  line-height: 1.7;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .accordion-button {
    padding: 16px 20px;
    font-size: 1rem;
  }
  
  .accordion-body {
    padding: 0 20px 20px 60px;
  }
}
</style>

